import {REPORT_ALL_CANDIDATES} from '/enum/records.enum';

export default {
  reportName: REPORT_ALL_CANDIDATES,
};
